import React, { useState } from 'react';
import { login } from '../api.js';

export default function Login({ onSuccess }) {
  const [email, setПочта] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      const user = await login(email.trim(), password);
      onSuccess(user);
    } catch (err) {
      setError(err.message || 'Login failed');
    }
    setBusy(false);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#f7fafc',
    }}>
      <form onSubmit={submit} style={{
        background: '#fff', padding: 32, borderRadius: 12,
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)', minWidth: 360,
      }}>
        <h2 style={{ marginTop: 0, marginBottom: 24 }}>Войти</h2>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 6, fontSize: 14 }}>Почта</label>
          <input
            type="email" value={email} onChange={(e) => setПочта(e.target.value)}
            required autoFocus disabled={busy}
            style={{ width: '100%', padding: '10px 12px', fontSize: 15,
                     border: '1px solid #e2e8f0', borderRadius: 6 }}
          />
        </div>

        <div style={{ marginBottom: 20 }}>
          <label style={{ display: 'block', marginBottom: 6, fontSize: 14 }}>Пароль</label>
          <input
            type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            required disabled={busy}
            style={{ width: '100%', padding: '10px 12px', fontSize: 15,
                     border: '1px solid #e2e8f0', borderRadius: 6 }}
          />
        </div>

        {error && (
          <div style={{
            background: '#fff5f5', color: '#c53030', padding: 10,
            borderRadius: 6, fontSize: 13, marginBottom: 12,
          }}>{error}</div>
        )}

        <button type="submit" className="btn-primary" disabled={busy}
                style={{ width: '100%', padding: '10px 16px' }}>
          {busy ? 'Signing in…' : 'Войти'}
        </button>
      </form>
    </div>
  );
}
